import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import NavDropdown from "react-bootstrap/NavDropdown";
import axios from "axios";
import config from "../../Config";
import TeacherRightsCheck from "./TeacherRightsCheck";
import { scrollToTop } from "../Shared/ScrollOnTop";
import { readIsWingHeadFromStorage, saveWingHeadStatus } from "./wingHeadStorage";

function TeacherMenu(props) {
  const [isWingHead, setIsWingHead] = useState(readIsWingHeadFromStorage());

  useEffect(() => {
    const syncFromStorage = () => setIsWingHead(readIsWingHeadFromStorage());
    window.addEventListener("wingHeadStatusUpdated", syncFromStorage);

    const accessKey = localStorage.getItem("AccessKey");
    const userId = parseInt(localStorage.getItem("ID"), 10);
    if (accessKey && userId > 0) {
      axios({
        method: "post",
        url: config.base_url + "Teacher/GetWingHeadStatus",
        headers: { "Content-Type": "application/json" },
        data: {
          AccessKey: accessKey,
          UserID: userId,
          MemberType: localStorage.getItem("MemberType") || "Teacher",
        },
      })
        .then((response) => {
          if (response.data.status_code === 1) {
            setIsWingHead(saveWingHeadStatus(response.data));
          }
        })
        .catch(() => {});
    }

    return () => window.removeEventListener("wingHeadStatusUpdated", syncFromStorage);
  }, []);

  return (
    <>
      <TeacherRightsCheck />
      <nav className="navbar navbar-expand-lg navbar-module MenuSticky">
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#NavbarSecondary"
            aria-controls="NavbarSecondary"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="NavbarSecondary">
            <ul className="navbar-nav m-auto">
              <li className="nav-item">
                <NavDropdown title="Profile">
                  {/* <NavLink
                    onClick={scrollToTop}
                    className="dropdown-item"
                    to="/teacher/UpdateProfile"
                  >
                    View Profile
                  </NavLink> */}
                  <NavLink
                    onClick={scrollToTop}
                    className="dropdown-item"
                    to="/teacher/change-password"
                  >
                    Change Password
                  </NavLink>
                  <NavLink
                    onClick={scrollToTop}
                    className="dropdown-item"
                    to="/teacher/update-photo"
                  >
                    Update Photo
                  </NavLink>
                </NavDropdown>
              </li>
              <li className="nav-item">
                <NavDropdown title="Exams">
                  <NavLink
                    onClick={scrollToTop}
                    className="dropdown-item"
                    to="/teacher/section-incharge"
                  >
                    Marks Entry as Section Incharge
                  </NavLink>
                  <NavLink
                    onClick={scrollToTop}
                    className="dropdown-item"
                    to="/teacher/subject-teacher"
                  >
                    Marks Entry as Subject Teacher
                  </NavLink>
                </NavDropdown>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/teacher/manage-sections"
                >
                  Manage Sections
                </NavLink>
              </li>
              {isWingHead && (
                <li className="nav-item">
                  <NavDropdown title="Wing Head">
                    <NavLink
                      onClick={scrollToTop}
                      className="dropdown-item"
                      to="/teacher/wing-sections"
                    >
                      Wing Sections
                    </NavLink>
                  </NavDropdown>
                </li>
              )}
              <li className="nav-item">
                <NavDropdown title="Attendence">
                  <NavLink
                    onClick={scrollToTop}
                    className="dropdown-item"
                    to="/teacher/MarkStudentAttendance"
                  >
                    Mark Attendence
                  </NavLink>
                  <NavLink
                    onClick={scrollToTop}
                    className="dropdown-item"
                    to="/teacher/atsummary"
                  >
                    Attendence Summary
                  </NavLink>
                </NavDropdown>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/teacher/ViewPaySlips"
                >
                  Pay Slips
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/teacher/events"
                >
                  School Events
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/teacher/diary"
                >
                  Student Diary
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/teacher/timetable"
                >
                  Class Time Table
                </NavLink>
              </li>
              


            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default TeacherMenu;
